import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';
import { heroXMark } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-update-email-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    LoadingButtonComponent,
  ],
  templateUrl: './update-email-modal.component.html',
  viewProviders: provideIcons({ heroXMark }),
})
export class UpdateEmailComponent implements OnInit {
  @Input() currentEmail: string = '';

  @Output() send = new EventEmitter<{ email: string }>();
  @Output() close = new EventEmitter<void>();

  formEmail!: FormGroup;
  isLoading = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.formEmail = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  sendCode() {
    if (this.formEmail.invalid) {
      this.formEmail.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const newEmail = this.formEmail.value.email;
    this.send.emit({ email: newEmail });

    setTimeout(() => {
      this.isLoading = false;
      this.closeModal();
    }, 500);
  }

  closeModal() {
    this.close.emit();
  }
}
